import type { LucideIcon } from 'lucide-react'
import type * as React from 'react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
	icon: LucideIcon
	title: string
	description?: string
	action?: React.ReactNode
	className?: string
}

export function EmptyState({
	icon: Icon,
	title,
	description,
	action,
	className,
}: EmptyStateProps) {
	return (
		<div
			className={cn(
				'flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed bg-card/40 px-6 py-16 text-center',
				className,
			)}
		>
			<div className="flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
				<Icon className="size-6" />
			</div>
			<div className="space-y-1">
				<p className="text-base font-medium tracking-tight">{title}</p>
				{description ? (
					<p className="mx-auto max-w-sm text-sm text-muted-foreground">
						{description}
					</p>
				) : null}
			</div>
			{action ? <div className="mt-2">{action}</div> : null}
		</div>
	)
}
